import { getChatSupportFirebaseConfig } from './chatSupportEnv'

/** Firebase web config for support chat (runtime Docker .env + /support-chat-config.js, or Vite .env). */
export function getChatSupportProjectId(): string {
  return getChatSupportFirebaseConfig().projectId
}
